import React, { useContext, useMemo } from 'react';
import moment from 'moment';

import WorkUsers from '@atom/components/common/workUsers/WorkUsers';
import fonts from '@atom/styles/fonts';
import { WorkOrder, WorkOrderUserGroup } from '@atom/types/work';
import { rollUpTaskUsers } from '@atom/utilities/userUtilities';
import { getWorkOrderStatusCalendarColor } from '@atom/utilities/workOrderStatusUtilities';

import WorkOrdersContext from '../WorkOrdersContext';

const styles = {
  event: {
    borderRadius: '0.375rem',
    fontSize: fonts.sm,
    marginBottom: '0.5rem',
    padding: '0.25rem 0.5rem',
  },
  avatars: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  textContain: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};

interface Props {
  workOrder: WorkOrder;
}

const WeekViewEvent = ({ workOrder }: Props) => {
  const { input, setInput } = useContext(WorkOrdersContext);
  const backgroundColor = getWorkOrderStatusCalendarColor(workOrder.statusId);

  const userGroups = useMemo(() => {
    return workOrder.tasks.reduce(
      (acc: WorkOrderUserGroup[], task) => [...acc, ...task.userGroups],
      [],
    );
  }, [workOrder]);

  const timeDisplay =
    workOrder.plannedStartDate && workOrder.dueDate ? (
      <div>
        {moment(workOrder.plannedStartDate).format('hh:mm A')} -{' '}
        {moment(workOrder.dueDate).format('hh:mm A')}
      </div>
    ) : null;

  return (
    <div
      style={{
        ...styles.event,
        ...styles.textContain,
        background: backgroundColor,
      }}
      // TODO: adjust styles to open preview over calendar
      onClick={() => setInput({ ...input, workOrderId: workOrder.id })}
    >
      {timeDisplay}
      <div
        title={workOrder.name}
        style={{ ...styles.textContain, fontWeight: 500 }}
      >
        {workOrder.name}
      </div>
      <div style={styles.avatars}>
        <WorkUsers
          users={rollUpTaskUsers(workOrder?.tasks as any)}
          userGroups={userGroups}
          avatarSize={18}
          useNoAssigneesIcon
          alignRight
        />
      </div>
    </div>
  );
};

export default WeekViewEvent;
